import React from 'react';
import {Navigate, useOutletContext} from 'react-router-dom';
import CinemaProperties from '../forms/CinemaProperties';
import SettingsPanel from './SettingsPanel';

export const CinemaSummary = ({ cinemaSettings }) => (
    <>
        <div className="me-3 text-center">
            <span className="fas fa-language me-2 text-primary" title="Spoken Language"/>
            <span>{cinemaSettings?.languageSpoken}</span>
        </div>
        <div className="me-3 text-center">
            <span className="fas fa-closed-captioning me-2 text-primary" title="Subtitle Language"/>
            <span>{cinemaSettings?.languageSubtitle}</span>
        </div>
        <div className="me-3 text-center">
            <span className="fas fa-volume-up me-2 text-primary" title="Audio Type"/>
            <span>{cinemaSettings?.audioType.join(' | ')}</span>
        </div>
        <div className="me-3 text-center">
            <span className="fas fa-expand me-2 text-primary" title="Aspect Ratio"/>
            <span className="text-capitalize">{cinemaSettings?.aspectRatio}</span>
        </div>
        <div className="me-3 text-center">
            <span className="fas fa-desktop me-2 text-primary" title="Resolution"/>
            <span>{cinemaSettings?.resolution}</span>
        </div>
        <div className="me-3 text-center">
            <span className="fas fa-film me-2 text-primary" title="Frame Rate"/>
            <span>{`${cinemaSettings?.framerate} fps`}</span>
        </div>
    </>
);

const CinemaTab = () => {
    const { organization, bacView, handleUpdate } = useOutletContext();

    if (!bacView) {
        return <Navigate to="../overview" replace />;
    }

    return (
        <SettingsPanel
            icon="fa-video"
            title="Cinema Properties"
            defaultOpen
            summary={<CinemaSummary cinemaSettings={organization?.cinemaSettings} />}
        >
            <CinemaProperties
                initialSettings={organization.cinemaSettings}
                onSave={handleUpdate('cinemaSettings')}
            />
        </SettingsPanel>
    );
};

export default CinemaTab;
